<template>
  <div>
    <anim-slide-viewer :videoUrl="videoUrl" v-if="videoUrl" />
    <div class="fullwidth spaceover">
      <style-browse-panel animation v-on:click="selectGallery" :gallery="gallery" />
    </div>
    <div class="fullwidth">
      <style-news-area :gallery="gallery" />
    </div>
    <testimonials-panel v-if="!$store.getters.isNonEnglish" />
    <template>
      <div class="fullwidth">
        <home-trees />
      </div>
      <div class="fullwidth darker">
        <team-panel />
      </div>
      <div class="fullwidth">
        <animated-ad />
      </div>
    </template>
    <div class="fullwidth darker">
      <div class="fullwidth darker">
        <style-browser animation />
      </div>
    </div>
  </div>
</template>

<script>
import StyleBrowser from '@/components/panels/StyleBrowser.vue'
import StyleBrowsePanel from '@/views/illustration/home/StyleBrowsePanel.vue'
import StyleNewsArea from './home/StyleAndNews.vue'
import MetatagPage from '@/mixins/MetatagPage.js'
import AnimSlideViewer from './home/AnimSlideViewer'
import TestimonialsPanel from '@/components/panels/TestimonialPanel.vue'
import HomeTrees from '@/views/illustration/home/HomeTrees.vue'
import TeamPanel from '@/views/illustration/home/TeamPanel.vue'
import AnimatedAd from './home/AnimatedAd.vue'

import stg from '@/data/home-style-galleries.js'

export default {
  mixins: [MetatagPage],
  components: {
    TestimonialsPanel,
    HomeTrees,
    TeamPanel,
    AnimatedAd,
    StyleBrowser,
    StyleBrowsePanel,
    StyleNewsArea,
    AnimSlideViewer
  },
  data () {
    return {
      galleryUrl:'',
      gallery: null,
      collapsed: false,
      mwidth:1024
    }
  },
  computed: {
    videoUrl () {
      //return 'mediastore/video' + this.galleryUrl + '.mp4'
      return 'mediastore/video/showfolio.mp4'
    }
  },
  created () {
    this.loadData()
  },
  mounted () {
    this.checkSize()
    window.addEventListener('resize', this.checkSize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkSize)
  },
  methods: {
    checkSize() {
      this.mwidth = window.innerWidth
    },
    async loadData () {
      this.galleryUrl = stg.getRandomGallery(true)
      if(this.$store.state.defaultAnimationGallery) {
        this.galleryUrl = this.$store.state.defaultAnimationGallery
      }
      this.gallery = await this.$store.dispatch('fetchGallery', this.galleryUrl)
    },
    selectGallery(gallery) {
      this.gallery = gallery
      this.$store.commit('setDefaultAnimationGallery', gallery.url)
    }
  }

}
</script>

